import type { ChangeEvent } from 'react';
import { FormErrorMessage, Radio, RadioGroup } from '@ksyos/design-system';
import React from 'react';
import type { IQuestionnaireItem } from '../../../../common/interfaces/IQuestionnaire';
import type { ValidationErrors } from '../../../utils/validation';
import { translateKey } from '../../../translate';
import { RadioGroupWrapper } from '../../elements/molecules/radioGroupWrapper/RadioGroupWrapper';
import { StyledCard } from '../../elements/molecules/styledCard/StyledCard';

interface IQuestonnaireAnswerOptionsProps {
    errors: ValidationErrors;
    onChange: (update: { [key: string]: string }) => void;
    questionItem: IQuestionnaireItem;
    value: string;
}

export function QuestionnaireAnswerOptions(props: IQuestonnaireAnswerOptionsProps) {
    const { errors, onChange, questionItem, value } = props;

    const hasError = errors.has('answers') && !value;

    return (
        <>
            <StyledCard error={hasError}>
                <RadioGroupWrapper>
                    <RadioGroup
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            onChange({ [questionItem.prefix]: event.target.value });
                        }}
                        value={value}
                    >
                        {getOptions()}
                    </RadioGroup>
                </RadioGroupWrapper>
            </StyledCard>

            {hasError && (
                <FormErrorMessage> {translateKey('validation.' + props.errors.get('answers'))}</FormErrorMessage>
            )}
        </>
    );

    function getOptions(): React.JSX.Element[] {
        return questionItem.answerOptions
            ? questionItem.answerOptions.map((option) => (
                  <Radio
                      id={`${questionItem.prefix} ${option.value}`}
                      key={option.value}
                      label={option.value}
                      value={option.value}
                  />
              ))
            : [];
    }
}
